import {getOutlet} from 'reconnect.js';
import Config from '../../../data.json';
import {viewable} from '../PermissionUtil';

export function getAdminRoutes() {
  const config = getOutlet('config');
  const userOutlet = getOutlet('user');

  return [
    {name: '首頁', path: '/'},
    {name: '組織', path: '/organization/'},
    {name: '商品', path: '/product/'},
    {name: '訂單', path: '/order/'},
    // {name: '會員', path: '/admin/users/'},

    // {name: '網站設定', path: '/admin/site/'},
    // {name: '前台手動更新', path: '/admin/rebuild-history'},
    // {
    //   name: '上傳工具',
    //   path: '__group-uploader',
    //   subroutes: [
    //     {name: '圖片上傳', path: 'image-uploader'},
    //     {name: '檔案上傳', path: 'file-uploader'},
    //   ],
    // },
    {name: '重設密碼', path: 'reset-password'},
    {name: '登出', path: 'logout'},
  ].filter(
    (_) => !!_ && viewable(userOutlet.getValue(), _.path),
    // (_.path === '/admin/rebuild-history' ? Config.allowGithubRebuild : true),
  );
}
